export const RECORD_TYPE = {
  STATUS: "status",
  CATEGORY: "category",
} as const;

export type RecordType = typeof RECORD_TYPE[keyof typeof RECORD_TYPE];

export const SETTING_SOURCE = {
  COMPANY: "company",
  CUSTOM: "custom",
} as const;

export type SettingSource = typeof SETTING_SOURCE[keyof typeof SETTING_SOURCE];

export const OBJECT_TYPE = {
  BIZ_PROJECT: "BizProject",
} as const;

export type ObjectType = typeof OBJECT_TYPE[keyof typeof OBJECT_TYPE];

export const FILTER_STATUS_TYPE = {
  CHECKED: "CHECKED",
  UNCHECKED: "UNCHECKED",
  SELECTED: "SELECTED",
} as const;

export const SPECIAL_FILTER_VALUE = {
  NULL: "__NULL__",
  ALL: "all",
} as const;

export const SPECIAL_FILTER_LABEL = {
  NULL: "(空白)",
  ALL: "すべて",
  STATUS: "ステータス",
  CATEGORY: "カテゴリー",
  EDIT_ADD: "編集・追加",
  SLICER: "スライサー",
  LOADING_FILTERS: "フィルターを読み込んでいます...",
} as const;

export const BUTTON_EDIT_MODE = {
  ALL: "all",
  STATUS: "status",
  CATEGORY: "category",
} as const;

export const SLICER_STORAGE_KEY = "slicer_filters";

export const SCREEN_NAME = {
  CHAT: "chat",
  LIST_MESS: "list_mess",
  TAXSHEET: "taxsheet",
  APP: "app",
  CLIENT: "client",
  PROJECT_MANAGE: "project_manage",
  PROJECT_MANAGE_DETAIL: "project_manage_detail",
  PERFORMANCE_APPRAISAL: "performance_appraisal",
  APPRAISAL_SHEET: "appraisal_sheet",
  WORKERS: "workers",
  BUSINESS_RPG: "business_rpg",
  BUSINESS_TRIP_REPORTS: "business_trip_reports",
  BUSINESS_MANUALS: "business_manuals",
  BUSINESS_FLOWCHARTS: "business_flowcharts",
  ROLE_PERMISSIONS: "role_permissions",
  COMPANY_POLICIES: "company_policies",
} as const;

export const HTTP_METHOD = {
  GET: "get",
  POST: "post",
  PATCH: "patch",
  DELETE: "delete",
} as const;

export const REFETCH_MODE = {
  ALWAYS: "always",
} as const;

export const WORKER_SETTING_MESSAGES = {
  SAVE_SUCCESS: "更新が完了しました。",
  RESET_SUCCESS: "設定をリセットしました。",
  STATUS_NAME_REQUIRED: "ステータス名を入力してください。",
  CATEGORY_NAME_REQUIRED: "カテゴリー名を入力してください。",
  STATUS_NAME_DUPLICATED: "ステータス名が重複しています。",
  CATEGORY_NAME_DUPLICATED: "カテゴリー名が重複しています。",
  CANNOT_EDIT_USED_VALUE: "当該値は使用中のため、編集できません。",
  DELETE_CONFIRM_TITLE:
    "選択肢は完全に削除されます。\n 削除項目が空白になり、元に戻せません。\n 本当に削除してもよろしいですか？",
  CONFIRM_CONTINUE_TITLE: "本当に続けてもよろしいですか？",
} as const;
